// Validate and get backend URL from environment
// Supports dynamic hostname detection for local network development
const getBackendBaseUrl = (): string => {
  const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL;

  // During build time (SSR/SSG), we allow empty backend URL
  // The actual API calls will only happen at runtime in the browser
  if (!backendUrl) {
    // Only warn in browser context (runtime), not during build
    if (typeof window !== 'undefined') {

    }
    // Return empty string during build - will be set at runtime
    return "";
  }

  // In browser, dynamically use the same hostname but with backend port
  // This allows accessing from localhost OR network IP without configuration changes
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const isLocalDev = currentHost === 'localhost' || currentHost.startsWith('192.168.') || currentHost.startsWith('10.');

    if (isLocalDev) {
      // Use same hostname as frontend but with backend port (8080)
      const protocol = window.location.protocol;
      return `${protocol}//${currentHost}:8080`;
    }
  }

  // Remove trailing slash if present
  return backendUrl.replace(/\/$/, '');
};

const config = {
  get baseUrl(): string {
    return getBackendBaseUrl();
  },
  SITE_URL: process.env.NEXT_PUBLIC_FRONTEND_URL || "",
  SESSION_NAME: process.env.NEXT_PUBLIC_SESSION_NAME || "insuracentral_session",
  tokenKey: "insuracentral_token",
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = getBackendBaseUrl();

  // If baseUrl is empty (build time), return a placeholder that will be replaced at runtime
  if (!baseUrl) {
    // Only throw error in browser context where we actually need the URL
    if (typeof window !== 'undefined') {
      throw new Error('Backend URL is not configured. Please set NEXT_PUBLIC_BACKEND_URL environment variable.');
    }
    // During build, return empty string - these URLs won't be used
    return '';
  }

  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // If endpoint already starts with 'api/', use as is
  if (cleanEndpoint.startsWith('api/')) {
    return `${baseUrl}/${cleanEndpoint}`;
  }

  // Otherwise, add 'api/' prefix
  return `${baseUrl}/api/${cleanEndpoint}`;
};

// Helper function to get backend URL without API prefix (for OAuth redirects, etc.)
export const getBackendUrl = (endpoint: string): string => {
  const baseUrl = getBackendBaseUrl();

  // If baseUrl is empty (build time), return a placeholder
  if (!baseUrl) {
    if (typeof window !== 'undefined') {
      throw new Error('Backend URL is not configured. Please set NEXT_PUBLIC_BACKEND_URL environment variable.');
    }
    return '';
  }

  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};

// Validate configuration on module load (only in browser at runtime)
if (typeof window !== 'undefined') {
  const backendUrl = getBackendBaseUrl();
  if (!backendUrl) {

  } else {
  }
}

export default config;